<div class="container-fluid" [class]="deviceDetector.isMobile() ? 'content-' + interaction?.orientation : ''">
    <div class="row">
        <div class="col-12 pt-3 interaction-header" [class]="'header-' + interaction?.type">
            <h3 class="text-center text-white text-uppercase font-weight-bold">
                {{interaction?.title}}
            </h3>
          <p class="text-white text-center">{{interaction?.instructions}}</p>
        </div>
        <div class="col-12">
            <app-timeline class="col-12" *ngIf="interaction?.content.customType === 'timeline'"
                          [interactionId]="interaction.id"></app-timeline>
        </div>
    </div>
</div>
